import { useMentiSpring } from '@mentimeter/motion/spring';
import { animated, easings } from '@react-spring/web';
import { useState } from 'react';

interface PinProps {
  x: number;
  y: number;
  label: string;
  radius: number;
  color: string;
  textColor: string;
}

export const Pin = ({ x, y, label, radius, color, textColor }: PinProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const [springs] = useMentiSpring({
    from: {
      opacity: 0,
      transform: 'scale(0.8)',
    },
    to: {
      opacity: 1,
      transform: 'scale(1)',
    },
    config: { duration: 400, easing: easings.easeInOutQuart },
  });

  return (
    <animated.g
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        ...springs,
        transformBox: 'fill-box',
        transformOrigin: 'center',
      }}
    >
      <circle
        fill={color}
        r={radius}
        cx={x}
        cy={y}
        stroke={textColor}
        strokeWidth={2}
        style={{
          transition: 'transform 0.2s, fill-opacity 0.2s',
          transform: `scale(${isHovered ? 1.2 : 1})`,
          fillOpacity: isHovered ? 0.32 : 1,
          transformBox: 'fill-box',
          transformOrigin: 'center',
          strokeOpacity: 1,
          filter: 'drop-shadow(0px 3.5px 14px  #0000001F)',
        }}
      />

      {!isHovered && (
        <text
          x={x}
          y={y}
          textAnchor="middle"
          dominantBaseline="central"
          fill={textColor}
          style={{ fontSize: radius * 0.7 + 'px', cursor: 'pointer' }}
        >
          {label}
        </text>
      )}
    </animated.g>
  );
};
